import React, { useEffect, Suspense, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import SearchControl from "../../components/LeftNavigation/GlobalSearch/SearchControl";
import { removeMapping } from "../../components/IFormDesignerLayout/RequestLogic";
import Tree from "./TreeMapFile";
import axios from "./../../axios";
import {
  fetchProcessModularData,
  fetchProcessTaskTemplate,
  fetchProcessGlobalTemplate,
} from "./../../components/IFormDesignerLayout/RequestLogic";
import CircularProgress from "@material-ui/core/CircularProgress";
import { addParentToFrame, findDataObjectListView, getFormId, parentFrameMappedId } from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import Backdrop from "@material-ui/core/Backdrop";
import "./index.css";
import { useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { Portal } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { ThemeJSON } from "../../components/IFormDesignerLayout/Theme/ThemeJSON";
import { GetStateFromData } from "../../components/CustomHooks/CustomHooks";
import { dragAndDropThroughMDM } from "../../Resources/globalFunctions";
import CustomizedAlert from "../Alert/CustomizedAlert";
import secureLocalStorage from "react-secure-storage";
import { recursionMapping } from "../../components/IFormDesignerLayout/SectionLayoutLogic";
import secureSessionStorage from "../../utils/secureSessionStorage";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const MappingFile = (props) => {
  const [stateOpen, setState] = React.useState(true);
  const { t } = useTranslation(["styles", "translation"]);
  const [mappedValueOfControl, setMappedValueOfControl] = React.useState("");
  const [mapId, setMapId] = React.useState("");
  const [mapVariableType, setMapVariableType] = React.useState("");
  const [dataMapId, setDataMapId] = React.useState("");
  const [parentObj, setParentObj] = React.useState("");
  const [mapValue, setMapValue] = React.useState("");
  const [varPercision, setVarPrecision] = React.useState("");
  const [variableLength, setVariableLength] = React.useState("");
  const [mapType, setMapType] = React.useState("");
  const [showMapButton, setShowMapButton] = React.useState("");
  const [mapBoundValue, setMapBoundValue] = React.useState("");
  const [processVal, setProcessVal] = React.useState("");
  const [unmapJsonState, setUnmapJsonState] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentMappedObject, setCurrentMappedObject] = React.useState("");
  const [dataObjectType, setDataObjectType] = React.useState("");
  const [unBounded, setUnBounded] = React.useState("");

  function agentHas(keyword) {
    return (
      window.navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) >
      -1
    );
  }

  let isSafariBrowser = function isSafari() {
    return (
      (!!window.ApplePaySetupFeature || !!window.safari) &&
      agentHas("Safari") &&
      !agentHas("Chrome") &&
      !agentHas("CriOS")
    );
  };
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;

  const contexts = GetStateFromData();

  const {
    updateJson,
    dataObjectsContent,
    mappingControlsIdMap,
    formState2,
    openCanvasForSubform,
    dataClassAdvacnceListview,
    activePage,
    appId,
    setDataObjectsContent,
    microFrontendData,
    setfilteredDataObject,
    filteredDataObject,
    fromQuickProps,
    setfromQuickProps,
    setOpenProperties,
    propertyPinned,
    setCurrentMappedDO,
    currentMappedDO,
    setfilteredDataObjectCopy,
    filteredDataObjectCopy,
    activeApplication,
  } = contexts.contexts;
  const { updatedComponentInFormState } = updateJson;
  const [snackBarInfo, setSnackBarInfo] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open1 } = snackBarInfo;
  const [portalState, setPortalState] = React.useState(
    microFrontendData?.formPageType || microFrontendData?.processName
      ? "Processes"
      : "Portals"
  );
  const [updateList, setUpdateList] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [search, setSearch] = useState("");
  const [currentMappedElement, setCurrentMappedElement] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [BasicVar, setBasicVar] = useState(true);
  const [ExtendedVar, setExtendedVar] = useState(true);
  const [SystemVar, setSystemVar] = useState(true);
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  useEffect(() => {
    if (Object.keys(dataObjectsContent).length === 0) {
      if (microFrontendData?.componentType === "TF") {
        setIsLoading(true);
        let jsonForProcess = {
          taskId: microFrontendData?.taskId,
          processdefId: microFrontendData?.processDefId,
          processState: microFrontendData?.statusType || "L",
        };
        fetchProcessTaskTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      } else if (microFrontendData?.componentType === "GT") {
        setIsLoading(true);
        var jsonForProcess = {
          globalTemplateId: microFrontendData?.templateId,
        };

        fetchProcessGlobalTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      } else if (portalState === "Portals") {
        fetch("/mdm-rest/app/dataobjects", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": jwtToken,
          },
          body: JSON.stringify({
            parent_id: appId,
            type: "AP",
            sort_order: "A",
            order_by: "1",
            records_to_fetch: "30",
            mode: "tree",
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (content) {
            if (content?.status?.subject === "No Data Objects found.") {
              setDataObjectsContent([]);
              setfilteredDataObject([]);
              setfilteredDataObjectCopy([]);
            } else {
              if (content.data.data_objects !== undefined) {
                var data = JSON.stringify(content.data.data_objects);

                let formId = getFormId()
                const jsonData = {
                  formId: activePage?.formId || formId.toString(),
                  data: `${data}`,
                };

                axios
                  .post("/idesign/getDataObjectsforMapping", jsonData, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    setDataObjectsContent(response.data["children"]);
                    setfilteredDataObject(response.data["children"]);
                    setfilteredDataObjectCopy(response.data["children"]);
                    setIsLoading(false);
                  })
                  .catch(function (error) {
                    if (error.response) {
                    }
                    console.log("error is", error);
                  });
              }
            }
          })
          .catch((err) => {
            console.log("error is", err);
          });
      } else if (portalState === "Processes") {
        setIsLoading(true);
        let jsonForProcess = {
          formId: microFrontendData?.formDefId,
          processdefId: microFrontendData?.processId,
          processState: microFrontendData?.statusType,
          processName: microFrontendData?.processName,
        };

        fetchProcessModularData(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    }
  }, []);

  useEffect(() => {
    var count = 0;
    var newStr = "";

    if (props.controlData && props.controlData["Mapping"] !== undefined) {
      var mapVar = "";
      var newStr2 = "";

      if (props.controlData["Mapping"] !== "") {
        mapVar = props.controlData["Mapping"];

        for (var i = mapVar.length - 1; i >= 0; i--) {
          if (mapVar.charAt(i) === ".") {
            count++;
          }
          if (count === 2) {
            break;
          }
          newStr += mapVar.charAt(i);
        }

        for (var i = newStr.length - 1; i >= 0; i--) {
          if (newStr.charAt(i) === ".") {
            continue;
          } else {
            newStr2 += newStr.charAt(i);
          }
        }

        setMappedValueOfControl(newStr2);
      }
    }
  }, []);

  const [mappedContentForAdvance, setMappedContentForAdvance] = React.useState([]);
  const [mappedContentForFrame, setMappedContentForFrame] = React.useState([])
  const mappedParentFrame = parentFrameMappedId(formState2, props?.controlData, props?.controlData?.frameIndex)
  let mappedContentForFrameCopy = useRef([])
  let mappedContentForAdvanceCopy = useRef([])

  const useStyles = makeStyles({
    root: {
      "& .MuiDrawer-root": {},
      "& .MuiBackdrop-root": {
        opacity: "0.2 !important",
      },
      "& .MuiDrawer-paperAnchorRight": {
        zIndex: 99999999,
        width: 378,
        right: t("styles:leftVal"),
        left: t("styles:rightVal"),
        overflowX: "hidden",
      },
    },
    list: {
      width: 250,
    },
    fullList: {
      width: "auto",
    },
    headingMapping: {
      color: "#000000",
      marginLeft: "15px",
      marginTop: "10px",
      fontSize: "13px",
      textAlign: "start",
    },
    headingMappingContent: {
      fontWeight: "bold",
    },

    columnUpperHeading: {
      height: "39px",
      width: "100%",
      backgroundColor: "#F5F5F5",
      border: "1px solid #F0F0F0",
      opacity: "1",
    },
    contentHeading: {
      font: "normal normal 600 12px/13px Open Sans",
      color: "#000000",
    },
    searchBar: {
      width: "273px",
      boxShadow: "none",
      marginRight: "8px",
    },
    searchFilterDiv: {
      display: "flex",
      alignItems: "center",
    },
    filterImg: {
      height: "28px !important",
      minWidth: "32px",
      border: "1px solid #C4C4C4",
      position: "relative",
      marginTop: "15px !important",
      cursor: "pointer",
    },
    clearText: {
      fontSize: "12px",
      color: "#0072C6",
      fontWeight: "600",
      paddingTop: "12px",
      cursor: "pointer",
    },
    filterHeader: {
      background: "#F8F8F8",
      height: "40px",
      borderRadius: "0px 1px 1px 1px",
      width: "270px",
      padding: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "12px",
      fontWeight: 600,
    },
    filterBody: {
      padding: "12px",
      height: "125px",
      fontSize: "12px",
      fontWeight: 600,
    },
    filterFooter: {
      background: "#F8F8F8",
      height: "40px",
      borderRadius: "0px 1px 1px 1px",
      padding: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    footerApply: {
      backgroundColor: "#0072C6",
      textTransform: "initial",
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#0072C6",
      },
    },
    footerCancel: {
      backgroundColor: "#FFFFFF",
      textTransform: "initial",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    bodyHeading: {
      paddingBottom: "8px",
      margin: "0 !important",
    },
    inputLabelCombine: {
      display: "flex",
      alignItems: "center",
      marginBottom: "11px",
    },
  });

  useEffect(() => {
    if (props.controlData.elem_type === "tile") {
      setMapValue(
        props.controlData?.tileContents[props.selectTileIndex]?.Mapping
      );
      setMapId(props.controlData?.tileContents[props.selectTileIndex]?.Mapping);
      setCurrentMappedObject(
        props.controlData?.tileContents[props.selectTileIndex]?.Mapping
      );
    } else if (
      props.controlData.style &&
      props.controlData.style["Mapping"] !== undefined
    ) {
      setMapValue(props.controlData.style["Mapping"]);
      setMapId(props.controlData.style["MappingId"]);
      setCurrentMappedObject(props.controlData.style["Mapping"]);
    }
  }, []);

  function identifyChildListviewOrTable(jsonArray){
    for(let i = 0; i < jsonArray?.length; i++){
      if(jsonArray[i]?.children && jsonArray[i]?.Unbounded === "Y"){
        for(let j = 0; j < jsonArray[i]?.children?.length; j++){
          jsonArray[i].children[j]["childListviewOrTableInsideAdvListview"] = true
        }
      }
    }
  }

  useEffect(() => {
    if (dataClassAdvacnceListview !== undefined) {
      var tempData = [];
      recursionMapping(filteredDataObject, tempData, dataClassAdvacnceListview);
      if(tempData?.[0]?.children)
      identifyChildListviewOrTable(tempData[0]?.children)
      setMappedContentForAdvance(tempData);
      mappedContentForAdvanceCopy.current = tempData;
    }
    if(mappedParentFrame && mappedParentFrame?.dataclass){
      let tempContent = [];
      recursionMappingForFrame(filteredDataObject, mappedParentFrame?.dataclass, tempContent);
      setMappedContentForFrame(tempContent);
      mappedContentForFrameCopy.current = tempContent;
    }
  }, []);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClear = () => {
    setBasicVar(true);
    setExtendedVar(true);
    setSystemVar(true);
    setfilteredDataObject([...filteredDataObjectCopy]);
    setSearch("");
  };
  
  // function recursionMapping(contentData, tempData) {
  //   Object.values(contentData).map((content) => {
  //     if (
  //       content["VariableName"] === dataClassAdvacnceListview ||
  //       content["treeName"] === dataClassAdvacnceListview
  //     ) {
  //       tempData.push(content);
  //     }
  //     if (content["children"]) {
  //       recursionMapping(content["children"], tempData);
  //     }
  //   });
  // }

  // function recursionMappingForFrame(contentData, frameDataClass, tempContent){
  //   Object.values(contentData).map((content) => {
  //     if (
  //       content["VariableName"] === frameDataClass ||
  //       content["treeName"] === frameDataClass
  //     ) {
  //       tempContent.push(content);
  //     }
  //     if (content["children"]) {
  //       recursionMappingForFrame(content["children"], frameDataClass, tempContent);
  //     }
  //   });
  // }

  function recursionMappingForFrame(contentData, frameDataClass, tempContent) {
    let stack = [...contentData]; // Initialize stack with root nodes
    
    while (stack.length > 0) {
      let content = stack.pop();
      
      if (content["VariableName"] === frameDataClass || content["treeName"] === frameDataClass) {
        tempContent.push(content);
      }
      
      if (content["children"] && content["children"].length > 0) {
        stack.push(...content["children"]);
      }
    }
  }

  function toggleDrawer() {
    if (!props?.controlData?.style["Mapping"]) {
      const newArr = currentMappedDO.filter((item) => item !== mapValue);
      setCurrentMappedDO((prev) => [...newArr]);
    }
    setMapValue("");
    setMapId("");
    setMapType("");
    setShowMapButton("");
    searchItemAndUpdate(filteredDataObjectCopy, currentMappedObject);
    if (currentMappedElement.length > 0) {
      removeMapping({ ...currentMappedElement[0].jsonToSend}).then(
        (response) => {
          setMapValue("");
          setMapId("");
          setShowMapButton("");
          setProcessVal("");
          setMapBoundValue("");
        }
      );
    }
    props.setMappingField(false);
    if (fromQuickProps) {
      if(!propertyPinned)
        setOpenProperties(false);
      setfromQuickProps(false);
    }
  }

  const createMappingJson = (dataObj) => {
    const mappingJson = {};

    if(dataObj && dataObj.children) {
      dataObj.children.map((column) => {
        if(column["VariableName"]) {
          mappingJson[column["VariableName"]] = column["VariableName"]
        }
      })
    }

    return mappingJson
  }


  function saveMapping() {
    let dataObj = findDataObjectListView(
      dataObjectsContent,
      mapValue,
      "children"
    );
    const parentFrameId =
      (props?.controlData?.sheetId ||
      props?.controlData?.sheetIndex ||
      props?.controlData?.sheetElementIndex) && !props?.controlData?.sheetFrameElementIndex
        ? document
            .getElementById(
              props.controlData?.dataclass
                ? props.controlData?.dataclass
                : props.controlData.id
            )
            ?.closest(`[elem_type=tabChild]`)
            ?.getAttribute("control_id")
        : document
            .getElementById(
              props.controlData?.dataclass
                ? props.controlData?.dataclass
                : props.controlData.id
            )
            ?.closest(`[elem_type=frame]`)
            ?.getAttribute("control_id");

    if (props.selectedVariableCallback) {
      if (mapValue) {
        props.selectedVariableCallback(mapValue);
        props.setMappingField(false);
        return;
      }
    }
    if (props.elementType === "tile") {
      if (mapValue === "") {
        delete props.selectedTileForMap.dataclass;
        delete props.selectedTileForMap.datamapid;
        delete props.selectedTileForMap.datamapVariableType;
        delete props.selectedTileForMap.TypeOfValue;
        delete props.selectedTileForMap.Mapping;
        delete props.selectedTileForMap.MappingId;
      } else {
        Object.assign(props.selectedTileForMap, {
          dataclass: mapValue,
          datamapid: dataMapId,
          datamapVariableType: mapVariableType,
          TypeOfValue: mapType,
          datamapPercision: varPercision,
          Mapping: mapValue,
        });
      }
    } else {
      if (mapValue === "") {
        props.controlData.style.Label =
          props?.controlData?.style?.Label || props.controlData.id;
        props.controlData.style["Mapping"] = "";
        delete props.controlData.style["MappingId"];
        delete props.controlData.dataclass;
        delete props.controlData.datamapVariableType;

        if (props.elementType === "doclist") {
          delete props.controlData.style["AllowAutoCreation"];
          delete props.controlData.style["AllowAutoCreationDO"];
          delete props.controlData.mappingJson
        }
        if (
          props.controlData.elem_type === "table" ||
          props.controlData.elem_type === "listview" ||
          props.controlData.elem_type?.toLowerCase() === "advancelistview"
        ) {
          if (props?.controlData?.columnList?.length) {
            props.controlData.columnList.forEach((item) => {
              delete item?.style?.["AssociatedField"];
              delete item?.style?.["complexFieldName"];
              delete item?.style?.["associatedControlId"];
              delete item?.style?.["complexFieldType"];
              delete item?.style?.["complexFieldVariableLength"];
              delete item?.style?.["complexFieldVariablePrecision"];

              // item.style["MaxLength"] = ThemeJSON?.tableColumn1?.["MaxLength"];
              // item.style["AllowAlphabets"] =
              //   ThemeJSON?.tableColumn1?.["AllowAlphabets"];
              // item.style["AllowNull"] = ThemeJSON?.tableColumn1?.["AllowNull"];
              // item.style["AllowSpaces"] =
              //   ThemeJSON?.tableColumn1?.["AllowSpaces"];
              // item.style["AllowSpecialChars"] =
              //   ThemeJSON?.tableColumn1?.["AllowSpecialChars"];
              // item.style["AllowNumbers"] =
              //   ThemeJSON?.tableColumn1?.["AllowNumbers"];
              // item.style["MinValue"] = ThemeJSON?.tableColumn1?.["MinValue"];
              // item.style["MaxValue"] = ThemeJSON?.tableColumn1?.["MaxValue"];
            });
          }
        }
      } else {
        if (
          props?.controlData?.elem_type === "listbox" &&
          (props?.controlData?.style?.Label === "" ||
            props?.controlData?.style?.Label === undefined)
        ) {
          props.controlData.style.Label = props?.controlData?.id;
        }
        if (props.controlData.id === props.controlData.style.Label) {
          props.controlData.style.Label = mapValue;
        }

        props.controlData.style.Mapping = mapValue;
        props.controlData.style.MappingId = mapId;
        props.controlData.style.BoundedValue = mapBoundValue;
        props.controlData.style.ProcessValue = processVal;
        props.controlData.style.variableLength = variableLength;

        if (
          props?.controlData?.elem_type === "textbox" &&
          (mapVariableType?.toLowerCase() === "integer" ||
            mapVariableType?.toLowerCase() === "long" ||
            mapVariableType?.toLowerCase() === "float")
        ) {
          props.controlData.style["Numerals"] = "true";
          if (props?.controlData?.style?.["Alphabets"] === "true")
            props.controlData.style["Alphabets"] = "false";
          if (props?.controlData?.style?.["AllowSpecialChars"] === "true")
            props.controlData.style["AllowSpecialChars"] = "false";
        } else if (
          props?.controlData?.elem_type === "textbox" &&
          mapVariableType?.toLowerCase() === "string"
        ) {
          props.controlData.style["Numerals"] = "true";
          props.controlData.style["Alphabets"] = "true";
          props.controlData.style["AllowSpecialChars"] = "true";
        }

        if(props?.controlData?.elem_type === "doclist") {
          props.controlData["mappingJson"] = createMappingJson(dataObj);
          props.controlData["mappingJson"] = {...(props.controlData["mappingJson"]), ...({
            DocType: "doctype",
            DocName: "docname",
            DocSize: "docsize",
            ResourceType: "resourcetype",
            DocComment: "doccomment",
            DocIndex: "docindex",
            NoOfPageInDoc: "noofpageindoc",
            DocControlID: "doccontrolid",
            Latitude: "latitude",
            Longitude: "longitude"
          })}
        }

        props.controlData=dragAndDropThroughMDM(dataObj,props?.controlData)
        
        Object.assign(props.controlData, {
          dataclass: mapValue,
          datamapid: dataMapId,
          datamapVariableType: mapVariableType,
          TypeOfValue: mapType,
          datamapPercision: varPercision,
          datamapVariableLength: variableLength,
          dataObjectType: dataObjectType,
          unBounded: unBounded,
        });

        mappingControlsIdMap.add(mapId);
      }
    }
    
    if (mapId) {
      searchItemAndUpdate(filteredDataObjectCopy, mapId);
    }

    if (parentObj?.length > 0)
      addParentToFrame(parentFrameId, formState2, parentObj);
    updatedComponentInFormState(props.controlData.id, props.controlData);
    setfilteredDataObjectCopy(() => [...filteredDataObjectCopy]);
    setfilteredDataObject(() => [...filteredDataObjectCopy]);
    props.setMappingField(false);
    setMapValue("");
    setMapId();
    setMapType();
    if (fromQuickProps) {
      if(!propertyPinned)
        setOpenProperties(false);
      setfromQuickProps(false);
    }
    setCurrentMappedElement([]);
  }

  function dfs(node, term, foundIDS) {
    let isMatching =
      node.VariableName?.toLowerCase() &&
      node.VariableName?.toLowerCase().indexOf(term) > -1;
      
    if(isMatching && node?.VariableName){
      foundIDS.push(node.VariableName?.toLowerCase());
    }

    if (Array.isArray(node.children)) {
      node.children.forEach((child) => {
        // const hasMatchingChild = dfs(child, term, foundIDS);
        if(!isMatching) dfs(child, term, foundIDS);
        // isMatching = isMatching || hasMatchingChild;
      });
    }
  }

  const handleClose1 = () => {
    setSnackBarInfo({ open1: false });
  };

  function filterDataByMatchedIds(data, matchedIDS) {
    const matchedIDSUpdated = matchedIDS.map((str) => str.toLowerCase());

    function filter(items) {
      return items
        .map((item) => {
          const isMatch = matchedIDSUpdated.some((matchedId) =>
            item.VariableName.toLowerCase().includes(matchedId)
          );
          const matchedIDSChildren = item.children ? filter(item.children) : [];
          if (isMatch) {
            return { ...item, children: item.children };
          }
          if (matchedIDSChildren.length > 0) {
            return { ...item, children: matchedIDSChildren };
          }
          return null;
        })
        .filter((item) => item !== null);
    }

    return filter(data);
  }

  function search1(term) {
    let children1 = filteredDataObjectCopy;
    if (dataClassAdvacnceListview !== undefined) {
      children1 = mappedContentForAdvanceCopy.current
    }
    else if(mappedParentFrame && mappedParentFrame?.dataclass){
      children1 = mappedContentForFrameCopy.current;
    }
    else if (dataObjectsContent) {
      children1 = filteredDataObjectCopy;
    }
    const dataNode = {
      children: children1,
    };
    const matchedIDS = [];
    dfs(dataNode, term, matchedIDS);
    return filterDataByMatchedIds((dataClassAdvacnceListview !== undefined) ? mappedContentForAdvanceCopy.current : (mappedParentFrame && mappedParentFrame?.dataclass) ? mappedContentForFrameCopy.current : filteredDataObjectCopy, matchedIDS);
  }
  function setSearching(search) {
    if (dataClassAdvacnceListview !== undefined) {
      let a = search1(search.toLowerCase())
      setMappedContentForAdvance(a);
    }
    else if(mappedParentFrame && mappedParentFrame?.dataclass){
      let a = search1(search.toLowerCase())
      setMappedContentForFrame(a);
    }
    else if (dataObjectsContent) {
      let a = search1(search.toLowerCase())
      setfilteredDataObject(a);
    }
  }
  const handleSearch = () => {
    setSearching(search);
  };

  const debounce = function (func, timeout) {
    let timer;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, timeout);
    };
  };

  useEffect(() => {
    if (dataObjectsContent?.length > 0) {
      const handleS = debounce(handleSearch, 500);
      handleS();
    }
  }, [search]);

  const handleFilterApply = () => {
    if (BasicVar && ExtendedVar && SystemVar) {
      let copyData = [...filteredDataObjectCopy];
      let filteredarr = copyData.filter(
        (item) =>
          item.VariableScope === "M" ||
          item.VariableScope === "S" ||
          item.VariableScope === "I" ||
          item.VariableScope === "U"
      );
      setfilteredDataObject(filteredarr);
      setAnchorEl(null);
    } else if (BasicVar && ExtendedVar) {
      let copyData = [...filteredDataObjectCopy];
      let filteredarr = copyData.filter(
        (item) => item.VariableScope === "I" || item.VariableScope === "U"
      );
      setfilteredDataObject(filteredarr);
      setAnchorEl(null);
    } else if (BasicVar && SystemVar) {
      let copyData = [...filteredDataObjectCopy];
      let filteredarr = copyData.filter(
        (item) =>
          item.VariableScope === "M" ||
          item.VariableScope === "S" ||
          item.VariableScope === "U" ||
          (item.VariableScope === "I" && item.VariableType === "11")
      );
      setfilteredDataObject(filteredarr);
      setAnchorEl(null);
    } else if (ExtendedVar && SystemVar) {
      let copyData = [...filteredDataObjectCopy];
      let filteredarr = copyData.filter(
        (item) =>
          item.VariableScope === "M" ||
          item.VariableScope === "S" ||
          (item.VariableScope === "I" && item.VariableType !== "11")
      );
      setfilteredDataObject(filteredarr);
      setAnchorEl(null);
    } else if (BasicVar) {
      let copyData = [...filteredDataObjectCopy];
      let filteredarr = copyData.filter(
        (item) =>
          item.VariableScope === "U" ||
          (item.VariableScope === "I" && item.VariableType === "11")
      );
      setfilteredDataObject(filteredarr);
      setAnchorEl(null);
    } else if (ExtendedVar) {
      let copyData = [...filteredDataObjectCopy];
      let filteredarr = copyData.filter(
        (item) => item.VariableScope === "I" && item.VariableType !== "11"
      );
      setfilteredDataObject(filteredarr);
      setAnchorEl(null);
    } else if (SystemVar) {
      let copyData = [...filteredDataObjectCopy];
      let filteredarr = copyData.filter(
        (item) => item.VariableScope === "M" || item.VariableScope === "S"
      );
      setfilteredDataObject(filteredarr);
      setAnchorEl(null);
    }
  };

  function searchItemAndUpdate(children, searchItem) {
    for (let item of children) {
      if (item.children) {
        searchItemAndUpdate(item.children, searchItem);
      }
      if (item.treeName === searchItem) {
        item.isMapped = true;
      }
    }
  }
  const classes = useStyles();
  useEffect(() => {
    document.getElementById("backdropDiv")?.focus();
  }, []);
  function handleEscapeKey(e) {
    if (e.code === "Escape") {
      toggleDrawer();
    }
  }

  return (
    <div>
      <Backdrop
        open={stateOpen}
        style={{ backgroundColor: "#70707050", opacity: "1", zIndex: 9 }}
      >
        <div
          tabIndex="0"
          onKeyDown={(e) => handleEscapeKey(e)}
          className="shade-main2"
          id="backdropDiv"
        ></div>

        <div
          className={
            isSafariBrowser() ? "question-popup-safari" : "question-popup"
          }
          style={
            !translationStyles1
              ? { opacity: 1, minWidth: "383px" }
              : { opacity: 1, minWidth: "383px", left: "0rem" }
          }
        >
          <div
            className={classes.columnUpperHeading}
            style={
              microFrontendData?.componentType
                ? { marginTop: "0px" }
                : { marginTop: "50px" }
            }
          >
            <div className={classes.headingMapping}>
              {t("translation:Data Class Mapping")}
            </div>
            {activeApplication?.defaultFormId ? (
              <SearchControl
                className={classes.searchBar}
                collapsed={false}
                collapsedWidth={"0px"}
                setSearch={setSearch}
                search={search}
              />
            ) : (
              <div className={classes.searchFilterDiv}>
                <SearchControl
                  className={classes.searchBar}
                  searchCollapsed={true}
                  collapsed={false}
                  width={"273px"}
                  setSearch={setSearch}
                  search={search}
                />
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={`${classes.filterImg} formBuilder-MuiButton-outlined`}
                  title={t("translation:Filters")}
                  onClick={handleClick}
                >
                  <img
                    src={require("../../Icons/Filter.svg").default}
                    alt="Filter Icon"
                    width={"15px"}
                  />
                </Button>
                <div className={classes.clearText} onClick={handleClear}>
                  {t("translation:Clear")}
                </div>
              </div>
            )}
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              style={{ direction: translationStyles1 ? "rtl" : "ltr" }}
            >
              <div className={classes.filterHeader}>
                <p>{t("translation:Filters")}</p>
                <p
                  className={classes.clearText}
                  onClick={handleClear}
                  style={translationStyles1 ? { marginRight: "10px" } : null}
                >
                  {t("translation:Clear")}
                </p>
              </div>
              <div className={classes.filterBody}>
                <p className={classes.bodyHeading}>
                  {t("translation:VariableType")}
                </p>
                <div className={classes.inputLabelCombine}>
                  <input
                    aria-label={"Basic Variable"}
                    type="checkbox"
                    id="BasicVar"
                    name="BasicVar"
                    checked={BasicVar}
                    onChange={() => setBasicVar(!BasicVar)}
                    className="inputMargin"
                  />
                  <label aria-label={"Basic Variable"} for="BasicVar">
                    {" "}
                    {t("translation:BasicVariables")}
                  </label>
                </div>
                <div className={classes.inputLabelCombine}>
                  <input
                    aria-label={"Extended Variable"}
                    type="checkbox"
                    id="ExtendedVar"
                    name="ExtendedVar"
                    checked={ExtendedVar}
                    onChange={() => setExtendedVar(!ExtendedVar)}
                    className="inputMargin"
                  />
                  <label aria-label={"Extended Variable"} for="ExtendedVar">
                    {t("translation:ExtendedVariables")}
                  </label>
                </div>
                <div className={classes.inputLabelCombine}>
                  <input
                    aria-label={"System Variable"}
                    type="checkbox"
                    id="SystemVar"
                    name="SystemVar"
                    checked={SystemVar}
                    onChange={() => setSystemVar(!SystemVar)}
                    className="inputMargin"
                  />
                  <label aria-label={"System Variable"} for="SystemVar">
                    {" "}
                    {t("translation:SystemVariables")}
                  </label>
                </div>
              </div>
              <div className={classes.filterFooter}>
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={`${classes.footerCancel} formBuilder-MuiButton-outlined`}
                  variant="outlined"
                  onClick={handleClose}
                >
                  {t("translation:Cancel")}
                </Button>
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={`${classes.footerApply} formBuilder-MuiButton-outlined`}
                  variant="contained"
                  onClick={handleFilterApply}
                >
                  {t("translation:Apply")}
                </Button>
              </div>
            </Popover>
            <Suspense fallback={<div>Loading</div>}>
              <div
                style={
                  dataObjectsContent
                    ? {
                        maxHeight: "72vh",
                        overflowY: "auto",
                        minHeight: "60px",
                        alignItems: "center",
                        justifyContent: "start",
                        paddingBottom: "25px",
                      }
                    : {
                        maxHeight: "72vh",
                        overflowY: "auto",
                        minHeight: "60px",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingBottom: "25px",
                      }
                }
              >
                {filteredDataObject?.length > 0 &&
                (openCanvasForSubform === "advanceListviewFromScratch" ? !!dataClassAdvacnceListview : true) ? (
                  <div style={{ marginBottom: "20px" }}>
                    <Tree
                      selectedVariableCallback={
                        props.selectedVariableCallback || null
                      }
                      data={
                        openCanvasForSubform === "advanceListviewFromScratch" &&
                        mappedContentForAdvance.length !== 0
                        ? mappedContentForAdvance
                        : (mappedParentFrame && mappedParentFrame?.dataclass)
                        ? mappedContentForFrame
                        : filteredDataObject
                      }
                      isWS={props.isWS}
                      elementType={props.elementType}
                      setCurrentMappedElement={setCurrentMappedElement}
                      mapId={mapId}
                      setMapId={setMapId}
                      setMapType={setMapType}
                      mapValue={mapValue}
                      setMapValue={setMapValue}
                      showMapButton={showMapButton}
                      setShowMapButton={setShowMapButton}
                      setUnmapJsonState={setUnmapJsonState}
                      setDataMapId={setDataMapId}
                      setParentObj={setParentObj}
                      processVal={processVal}
                      setProcessVal={setProcessVal}
                      setUpdateList={setUpdateList}
                      mapBoundValue={mapBoundValue}
                      setMapBoundValue={setMapBoundValue}
                      setMapVariableType={setMapVariableType}
                      setVarPrecision={setVarPrecision}
                      setVariableLength={setVariableLength}
                      setCurrentMappedObject={setCurrentMappedObject}
                      currentMappedObject={currentMappedObject}
                      setDataObjectType={setDataObjectType}
                      setUnBounded={setUnBounded}
                      setSnackBarInfo={setSnackBarInfo}
                      setAlertMsg={setAlertMsg}
                      handleClose1={handleClose1}
                      mappedContentForAdvance={mappedContentForAdvance}
                    />
                  </div>
                ) : isLoading === true ? (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "50vh",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "50vh",
                    }}
                  >
                    {t("translation:No Data Object Found.")}
                  </div>
                )}
              </div>
            </Suspense>
          </div>

          <footer
            className={isSafariBrowser() ? "footerWrapMac" : "footerWrap"}
          >
            <div
              style={
                !translationStyles1
                  ? {
                      paddingTop: "6px",
                      position: "inherit",
                      right: "15px",
                      display: "flex",
                      justifyContent: "space-between",
                    }
                  : {
                      paddingTop: "6px",
                      position: "inherit",
                      display: "flex",
                      left: "2rem",
                      justifyContent: "space-between",
                    }
              }
            >
              <Button
                disableFocusRipple
                disableRipple
                tabIndex={0}
                className={`formBuilder-MuiButton-outlined`}
                variant="outlined"
                style={{
                  width: "54px",
                  height: "28px",
                  fontSize: "12px",
                  textTransform: "none !important",
                  borderRadius: "4px",
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                  color: "rgba(0, 0, 0, 0.87)",
                }}
                onClick={() => toggleDrawer()}
              >
                {t("translation:Cancel")}
              </Button>
              <Button
                disableFocusRipple
                disableRipple
                tabIndex={0}
                className={`formBuilder-MuiButton-outlined`}
                variant="contained"
                style={{
                  backgroundColor: "#0072c6",
                  color: "white",
                  width: "63px !important",
                  height: "28px",
                  fontSize: "12px",
                  marginLeft: "12px",
                  textTransform: "none !important",
                  borderRadius: "3px",
                }}
                onClick={() => saveMapping()}
              >
                {t("translation:Save")}
              </Button>
            </div>
          </footer>
        </div>
      </Backdrop>

      {snackBarInfo?.open && 
        <CustomizedAlert
          alertData={snackBarInfo}
        />
      }
      {/* <div style={{ position: "absolute" }}>
      <Portal container={document.getElementById('body')}>
        <Snackbar
          style={{top:"16px"}}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={open1}
          onClose={handleClose1}
          autoHideDuration={1000}
          key={vertical + horizontal}
        >
          <Alert
            severity="info"
            style={{
              width: "290px",
              backgroundColor: "#fae18e",
              color: "#000000",
              fontFamily: "Open Sans",
              fontSize: "13px",
            }}
          >
            {alertMsg}
          </Alert>
        </Snackbar>
        </Portal>
      </div> */}
    </div>
  );
};

export default MappingFile;
